import { render, staticRenderFns } from "./account-detail.view.vue?vue&type=template&id=528380a5&"
import script from "./account-detail.view.ts?vue&type=script&lang=js&"
export * from "./account-detail.view.ts?vue&type=script&lang=js&"
import style0 from "./account-detail.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports